export class ContactAccountModel {
	accountId: number;
	accountNumber: string;
	personId: number;
	identificationNumber: string;
	fullname: string;
	phoneNumber: string;
	isHOH: boolean;
	registeredEntityNameId: string;
}
